import { Box, Checkbox, FormControlLabel, Typography, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react'
import { AbsentBtn, PresentBtn } from '../../shared/utils/AttendaceButton';
import { useStudentListStatus } from '../../assets/api/UseStudentGetApi';
import useAuthStore from '../../store/useAuthStore';
import CustomPagination from '../../shared/utils/CustomPagination';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import { useStudentAtdStore } from '../../store/useStudentAtdStore';
import { useToaster } from '../../shared/utils/ToasterProvider';

const StudentAttendanceList = ({ item }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const { user } = useAuthStore();
    const { course_id } = item
    const { data: studentlist, isLoading } = useStudentListStatus({ course_id: course_id, apartment_id: item?.apartment_id, trainer_id: user?.id });
    const { data, addRow, filterById, removeAll } = useStudentAtdStore();
    const [checked, setChecked] = useState(false);
    const { showToaster } = useToaster();
    const handleCheckboxChange = (event) => {
        const allPresent = studentlist?.data?.every(student => student.attendance_status === 1);
        if (allPresent) {
            showToaster('Attendance has already been added for All  student.', 'Warning', 'warning')
            return;
        }
        if (!checked) {
            setChecked(event.target.checked);
            const formdata = studentlist?.data?.map((item) => ({
                "student_id": item.student_id,
                "attendance_status": "1",
                "remarks": "Good engagement"
            }));
            addRow(formdata);
        } else {
            setChecked(event.target.checked);
            removeAll();
        }


    };
    const handlePresent = (student_id) => {
        const student = studentlist?.data?.find((item) => item.student_id === student_id);
        if (student && !data.some((item) => item.student_id === student_id)) {
            addRow(
                {
                    "student_id": student.student_id,
                    "attendance_status": "1",
                    "remarks": "Good engagement"
                }
            );
        }
    }

    const handleAbsent = (student_id) => {
        filterById((prevData) => prevData.filter((item) => item.student_id !== student_id));
        setChecked(false);

    }

    const handleRemarkChange = (student_id, newRemark) => {
        filterById((prevData) =>
            prevData.map((item) =>
                item.student_id === student_id ? { ...item, remarks: newRemark } : item
            )
        );
    };

    const studentRows = studentlist?.data?.map((item, index) => ({
        id: index + 1,
        studentName: item?.lastname,
        attendance: "Present",
        remark: item?.remarks,
        student_id: item?.student_id
    }));

    const studentColumns = [
        {
            field: "id",
            headerName: "Sr No",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "studentName",
            headerName: "Student Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "attendance",
            headerName: "Attendance",
            flex: 1,
            renderCell: (params) => {
                const studentData = studentlist?.data?.[params.row.id - 1];
                const student_id = studentData?.student_id;
                const ispresent = studentData?.attendance_status;
                const attendanceRecord = data.find((record) => record.student_id === student_id);
                const handleClick = () => {
                    if (ispresent === 1) {
                        showToaster('Attendance has already been added for this student.', 'Warning', 'warning')
                    } else {
                        if (attendanceRecord) {
                            handleAbsent(student_id);
                        } else {
                            handlePresent(student_id);
                        }
                    }
                };

                const showPresent = ispresent === 1 || attendanceRecord;
                return showPresent
                    ? <PresentBtn onClick={handleClick} />
                    : <AbsentBtn onClick={handleClick} />;
            },
        },
        {
            field: "remark",
            headerName: "Remarks",
            flex: 1,
            renderCell: (params) => {
                const studentData = studentlist?.data?.[params.row.id - 1];
                const student_id = params.row.student_id;
                const attendanceRecord = data.find((record) => record.student_id === student_id);
                const remarkValue = attendanceRecord?.remarks ?? params.row.remark;
                const ispresent = studentData?.attendance_status;
                return (
                    <TextField
                        variant="standard"
                        onKeyDown={(e) => e.stopPropagation()}
                        value={remarkValue}
                        onChange={(e) => {
                            if (ispresent === 1) {
                                showToaster('Attendance has already been added for this student.', 'Warning', 'warning')
                            } else {
                                handleRemarkChange(student_id, e.target.value);
                            }
                        }}
                        fullWidth
                    />
                );
            },
        },


    ];
    return (
        <Box>
            {
                !isLoading && (
                    <>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checked}
                                    onChange={handleCheckboxChange}
                                    sx={{
                                        color: "#000",
                                        "&.Mui-checked": { color: "#000" },
                                        transform: "scale(1)"
                                    }}
                                />
                            }
                            label="Mark all Present"
                        />
                        <DataGrid
                            rows={studentRows}
                            columns={studentColumns}
                            pagination
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            pageSizeOptions={[10]}
                            slots={{
                                pagination: () => (
                                    <CustomPagination
                                        paginationModel={paginationModel}
                                        setPaginationModel={setPaginationModel}
                                        totalRows={studentlist?.data?.length || 0}
                                        pageSize={paginationModel.pageSize}
                                    />

                                ),
                            }}
                        />
                    </>
                )
            }

            {
                isLoading && (
                    <SkeletonCom height={"200px"} />
                )
            }

        </Box>


    )
}

export default StudentAttendanceList